var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.8164,
    r: 16,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 17.5125L19.9772 17.5125L16.9341 20.5069L17.9252 21.4824L22.666 16.8158L17.9252 12.1491L16.9341 13.1246L19.9772 16.119L9.99935 16.119L9.99935 17.5125Z",
    fill: "#082980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow_circle.a9a8dfaaea3e4544807926c6f8be6fa6.svg";
export { ForwardRef as ReactComponent };